module.exports = __webpack_public_path__ + "img/Weapon_89.2271a603.png";